import { useState } from "react";

export const useDateFilters = () => {
    const [selectedDateRange, setSelectedDateRange] = useState({
        label: "Last 7 Days",
        value: "last7d",
    });

    const [selectedCompareDate, setSelectedCompareDate] = useState({
        label: "Prev. Period",
        value: "previous_period",
    });

    return {
        selectedDateRange,
        setSelectedDateRange,
        selectedCompareDate,
        setSelectedCompareDate,
    };
};